import React, {useEffect, useState} from 'react';
import Input from '../Input';
import CustomSelect from '../CustomSelect';
import {useTranslation} from '../../hooks/useTranslation';

export default function EquipmentTypeModal({
  exit,
  list,
  addedInspections,
  setAddedInspections,
  pickedInspection,
  setPickedInspection,
  saveEquipment,
  comparisonList,
}) {
  const {t} = useTranslation();
  const [newList, setNewList] = useState([]);
  useEffect(() => {
    setNewList(
      list.filter(o1 => !comparisonList?.some(o2 => o1.id === o2.form.id)),
    );
  }, []);

  return (
    <div className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('equipmentTypeModal.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div style={{padding: '16px 26px 0 16px'}}>
          <Input
            image={'/assets/icons/search.svg'}
            id='inspection_search'
            name='inspection_search'
            placeholder={t('equipmentTypeModal.searchPlaceholder')}
            type={'text'}
          />
        </div>

        <div className='modal__content-body addInspection'>
          {newList?.map(inspection => (
            <div
              className={`editType__inspection ${inspection.id === pickedInspection?.id ? 'active' : ''}`}
              key={inspection.id}
              onClick={() => setPickedInspection(inspection)}
            >
              {inspection.name}
            </div>
          ))}
        </div>
        <div className='modal__content-bottom'>
          <button
            className='close'
            onClick={() => {
              setPickedInspection(null);
              exit();
            }}
          >
            {t('equipmentTypeModal.buttons.close')}
          </button>
          <button className='save' onClick={() => saveEquipment()}>
            {t('equipmentTypeModal.buttons.save')}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
}
